import React, { PropTypes, Component } from 'react';
import classnames from 'classnames';

export default class Question extends Component {
  constructor(props) {
    super(props);
    this.toggleQuestion = this.toggleQuestion.bind(this);
    this.state = { show: false };
  }

  toggleQuestion(e) {
    e.preventDefault();
    this.setState({ show: !this.state.show });
  }

  render() {
    const { question, answer } = this.props;
    const { show } = this.state;
    const classes = classnames('question', { show, hidden: !show });
    return (<div className={classes}>
      <button onClick={this.toggleQuestion}>
        <h3 className="question-title">{ question }</h3>
        <i className="fa fa-plus" />
        <i className="fa fa-minus" />
      </button>
      <div
        className={classnames('answer', { 'faq-show': show })}
        dangerouslySetInnerHTML={{ __html: answer }}
      />
    </div>);
  }
}

Question.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./help/components/question.jsx